import { render, staticRenderFns } from "./AttackInfo.vue?vue&type=template&id=57baf71e&scoped=true&"
import script from "./AttackInfo.vue?vue&type=script&lang=js&"
export * from "./AttackInfo.vue?vue&type=script&lang=js&"
import style0 from "./AttackInfo.vue?vue&type=style&index=0&id=57baf71e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57baf71e",
  null
  
)

export default component.exports